/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScoringHealthStatus } from './ScoringHealthStatus';
import {
    ScoringHealthStatusFromJSON,
    ScoringHealthStatusFromJSONTyped,
    ScoringHealthStatusToJSON,
    ScoringHealthStatusToJSONTyped,
} from './ScoringHealthStatus';

/**
 * 
 * @export
 * @interface ScoringHealthStateResponse
 */
export interface ScoringHealthStateResponse {
    /**
     * 
     * @type {ScoringHealthStatus}
     * @memberof ScoringHealthStateResponse
     */
    status: ScoringHealthStatus;
    /**
     * Where the player is right now — "In Match", "Lobby", "Main Menu". Present when GREEN or RED.
     * @type {string}
     * @memberof ScoringHealthStateResponse
     */
    label?: string;
}



/**
 * Check if a given object implements the ScoringHealthStateResponse interface.
 */
export function instanceOfScoringHealthStateResponse(value: object): value is ScoringHealthStateResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ScoringHealthStateResponseFromJSON(json: any): ScoringHealthStateResponse {
    return ScoringHealthStateResponseFromJSONTyped(json, false);
}

export function ScoringHealthStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoringHealthStateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': ScoringHealthStatusFromJSON(json['status']),
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function ScoringHealthStateResponseToJSON(json: any): ScoringHealthStateResponse {
    return ScoringHealthStateResponseToJSONTyped(json, false);
}

export function ScoringHealthStateResponseToJSONTyped(value?: ScoringHealthStateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': ScoringHealthStatusToJSON(value['status']),
        'label': value['label'],
    };
}

